import React, { useState } from "react";
import { useLang } from "../../context/LangContext";
import { useCMS } from "../../context/CMSContext";
import { useInView } from "../../hooks/useInView";
import SectionHeader from "../common/SectionHeader";
import styles from "./Listings.module.css";

// Single tile with skeleton → image fade-in
function Tile({ item, visible, delay }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className={`${styles.tile} ${visible ? styles.visible : ""}`}
      style={{ transitionDelay: delay }}
    >
      {/* Skeleton shown until image loads */}
      {!loaded && <div className={styles.skeleton} />}

      <img
        src={item.imageUrl}
        alt={item.title || "Listing"}
        className={`${styles.tileImage} ${loaded ? styles.tileLoaded : styles.tileHidden}`}
        loading="lazy"
        decoding="async"
        draggable={false}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}

function Listings() {
  const { t } = useLang();
  const { cms, loading } = useCMS();
  const [ref, visible] = useInView(0.01);

  const cmsItems = cms?.websiteListings?.items ?? [];
  const items = cmsItems.filter((item) => item.imageUrl?.trim());

  if (loading || items.length === 0) return null;

  return (
    <section id="listings" className={styles.section} ref={ref}>
      <div className="container">
        <SectionHeader
          label={t.listings.label}
          heading={t.listings.heading}
          subheading={t.listings.subheading}
          labelColor="#1718BF"
        />
        <div className={styles.grid}>
          {items.map((item, i) => (
            <Tile
              key={item.listingId ?? i}
              item={item}
              visible={visible}
              delay={`${i * 50}ms`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Listings;
